export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/5930ecba45f376e7.jpg"